module.exports = __webpack_public_path__ + "static/media/about.1ed07fcf.md";